import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO, { orgJsonLd, breadcrumbJsonLd } from "../components/SEO";
import Reveal from "../components/Reveal";
import { SectionHead } from "../components/StatsBar";
import Icon from "../components/Icon";
import LeadForm from "../components/LeadForm";
import { SERVICES, SERVICE_CATEGORIES } from "../data/siteData";

export default function ServicesPage() {
  return (
    <>
      <SEO
        title="All Services A–Z | CA, CS, Legal & Fundraising Advisory — Complisure Counsultancy"
        description="Company registration, ROC compliance, taxation, audit, Virtual CFO, business valuation, fundraising advisory, M&A, legal and PR services across India."
        canonical="https://compliance-capital-1.preview.emergentagent.com/services"
        jsonLd={[orgJsonLd, breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Services", path: "/services" }])]}
      />
      <section className="relative overflow-hidden pb-16 pt-36">
        <div className="blob blob-float right-[-8%] top-[-10%] h-96 w-96 bg-brand-blue/10" />
        <div className="dot-grid absolute inset-0 opacity-[0.1]" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6">
          <Reveal>
            <h1 className="max-w-3xl font-display text-4xl font-extrabold tracking-[-0.02em] text-brand-navy sm:text-5xl">
              Every service your company will ever need — <span className="text-gradient">under one roof</span>
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-brand-gray sm:text-lg">
              Eleven practice areas staffed by 40+ CA/CS professionals and 15+ legal advisors. One engagement manager, one WhatsApp group, zero finger-pointing.
            </p>
          </Reveal>

          {SERVICE_CATEGORIES.map((cat) => (
            <div key={cat} className="mt-16">
              <Reveal>
                <h2 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-brand-blue">{cat}</h2>
              </Reveal>
              <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                {SERVICES.filter((s) => s.category === cat).map((s, i) => (
                  <Reveal key={s.slug} delay={i * 0.07}>
                    <Link to={`/services/${s.slug}`} data-testid={`services-page-card-${s.slug}`} className="glass card-lift group flex h-full flex-col rounded-3xl p-7">
                      <span className="mb-5 flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-brand-blue to-brand-sky text-white shadow-lg shadow-brand-blue/25">
                        <Icon name={s.icon} className="h-5 w-5" />
                      </span>
                      <h3 className="font-display text-lg font-bold tracking-tight text-brand-navy group-hover:text-brand-blue">{s.name}</h3>
                      <p className="mt-2 flex-1 text-sm leading-relaxed text-brand-gray">{s.short}</p>
                      <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-blue transition-all group-hover:gap-3">
                        Explore <ArrowRight className="h-4 w-4" />
                      </span>
                    </Link>
                  </Reveal>
                ))}
              </div>
            </div>
          ))}

          <div className="mt-20 grid items-center gap-10 lg:grid-cols-2">
            <Reveal>
              <h2 className="font-display text-3xl font-bold tracking-tight text-brand-navy">Not sure which service you need?</h2>
              <p className="mt-4 text-base leading-relaxed text-brand-gray">
                Tell us where your business is and where it's going — a senior advisor will map the exact engagement within one working day. Free, fixed-quote, no obligation.
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <LeadForm sourcePage="/services" />
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
